import React from "react";
import styles from "./ContactUs.module.scss";
import { useNavigate } from "react-router-dom";

export const ContactUs = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1>Encontrar el mejor lugar para vivir</h1>
        <p>
          En <span>MS Bienes Raices</span> estamos comprometidos a ayudarte a
          encontrar el lugar perfecto para ti y tu familia. Nuestros agentes
          están listos para ayudarte a encontrar tu próximo hogar.
        </p>
        <button onClick={() => navigate('/contact')}>Contactanos</button>
      </div>
    </div>
  );
};
